"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderSkillsSection = renderSkillsSection;
var _litHtml = require("lit-html");
require("solid-ui/components/actions/button");
var _textUtils = require("../../textUtils");
require("./SkillsSection.css");
var _SkillsEditDialog = require("./SkillsEditDialog");
var _profileIcons = require("../../icons-svg/profileIcons");
var _texts = require("../../texts");
var _collapsibleSection = require("../shared/collapsibleSection");
var _mutations = require("./mutations");
var _errorDisplay = require("../../utils/errorDisplay");
const removeSkillFailedMessageText = 'Unable to remove your skill.';
function setSkillsSectionError(section, message) {
  const errorBox = section.querySelector('.profile-section-inline-error');
  if (!errorBox) return;
  if (!message) {
    errorBox.textContent = '';
    errorBox.hidden = true;
    errorBox.setAttribute('aria-hidden', 'true');
    return;
  }
  errorBox.textContent = message;
  errorBox.hidden = false;
  errorBox.setAttribute('aria-hidden', 'false');
  errorBox.focus();
}
function renderSkillItem(detail, store, subject, viewerMode, onSaved) {
  if (!detail) return (0, _litHtml.html)``;
  const handleRemove = async event => {
    event.preventDefault();
    if (viewerMode !== 'owner') return;
    const removeButton = event.currentTarget;
    const skillRow = removeButton?.closest('.skills__item');
    const section = event.currentTarget?.closest('[data-profile-section="skills"]');
    const removeRow = {
      name: detail.name,
      publicId: detail.publicId,
      entryNode: detail.entryNode.value,
      status: 'deleted'
    };
    try {
      removeButton?.setAttribute('disabled', '');
      removeButton?.setAttribute('aria-busy', 'true');
      removeButton?.setAttribute('data-loading', 'true');
      skillRow?.setAttribute('data-pending', 'true');
      await (0, _mutations.processSkillsMutations)(store, subject, {
        create: [],
        update: [],
        remove: [removeRow]
      });
      if (section) {
        setSkillsSectionError(section, null);
      }
      if (onSaved) {
        await onSaved();
      }
    } catch (error) {
      if (section) {
        setSkillsSectionError(section, (0, _errorDisplay.formatDisplayError)(error, removeSkillFailedMessageText));
      }
    } finally {
      removeButton?.removeAttribute('disabled');
      removeButton?.setAttribute('aria-busy', 'false');
      removeButton?.removeAttribute('data-loading');
      skillRow?.removeAttribute('data-pending');
    }
  };
  return (0, _litHtml.html)`
    <li class="skills__item" role="listitem">
      <span class="skills__item-label">${(0, _textUtils.strToUpperCase)(detail.name)}</span>
      ${viewerMode === 'owner' ? (0, _litHtml.html)`
            <span class="skills__item-tail">
              <solid-ui-button
                type="button"
                variant="icon"
                size="sm"
                class="skills__remove-button"
                aria-label=${`Remove ${detail.name} skill`}
                @click=${handleRemove}
              >
                <span slot="icon" aria-hidden="true">${_profileIcons.deleteIcon}</span>
              </solid-ui-button>
            </span>
          ` : ''}
    </li>
  `;
}
function renderSkillsSectionDefault(store, subject, skills, viewerMode, onSaved) {
  const hasSkills = Array.isArray(skills) && skills.length > 0;
  const isOwner = viewerMode === 'owner';
  return (0, _litHtml.html)`
    <section
      class="profile__section profile-section-collapsible profile-section-collapsible--inline-mobile-actions"
      data-profile-section="skills"
      aria-labelledby="skills-heading"
      role="region"
      tabindex="-1"
      data-expanded="false"
    >
      <header class="profile__section-header profile-section-collapsible__header">
        <h3 id="skills-heading">${_texts.skillsHeadingText}</h3>
        <div class="profile-section-collapsible__actions">
          ${isOwner ? (0, _litHtml.html)`
            <solid-ui-button
              type="button"
              variant="secondary"
              size="sm"
              class="profile__action-button profile-action-text profile-section-collapsible__edit-button"
              aria-label="Add or edit skills"
              @click=${event => (0, _SkillsEditDialog.createSkillsEditDialog)(event, store, subject, skills, viewerMode, onSaved)}
            >
              <span class="profile-section-collapsible__edit-label profile__add-more-content">
                <span class="profile__add-more-icon" aria-hidden="true">${_profileIcons.addIcon}</span>
                <span>Add More</span>
              </span>
              <span class="profile-section-collapsible__edit-icon" aria-hidden="true">${_profileIcons.editIcon}</span>
            </solid-ui-button>
          ` : (0, _litHtml.html)``}
          <solid-ui-button
            type="button"
            variant="icon"
            size="sm"
            class="profile-section-collapsible__toggle-button"
            aria-label="Toggle skills section"
            aria-controls="skills-panel"
            aria-expanded="false"
            @click=${_collapsibleSection.toggleCollapsibleSection}
          >
            <span slot="icon" class="profile-section-collapsible__chevron" aria-hidden="true">${_profileIcons.chevronDownIcon}</span>
          </solid-ui-button>
        </div>
      </header>
      <div
        id="skills-panel"
        class="profile-section-collapsible__content"
      >
        ${hasSkills ? (0, _litHtml.html)`
              <ul class="skills__list" role="list" aria-label="Professional skills and competencies">
                ${skills.map(detail => renderSkillItem(detail, store, subject, viewerMode, onSaved))}
              </ul>
              <div
                class="profile-section-inline-error"
                role="alert"
                aria-live="assertive"
                aria-atomic="true"
                aria-hidden="true"
                tabindex="-1"
                hidden
              ></div>
            ` : (0, _litHtml.html)`<p>No skills added yet.</p>`}
      </div>
    </section>
  `;
}
function renderOwnerEmptySkillsContent(_store, _subject, _skills, _viewerMode, _onSaved) {
  return (0, _litHtml.html)`
      <div class="profile__empty-state-content" role="group" aria-label="Empty skills section">    
        <div class="skills__empty-icon-wrapper">
          <span class="skills__empty-icon">${_profileIcons.lighteningIcon}</span>
        </div>
        <p class="profile__empty-state-message skills__empty-message">
            No skills added yet.
        </p>
      </div>
  `;
}
function renderOwnerEmptySkillsSection(store, subject, skills, viewerMode, onSaved) {
  return (0, _litHtml.html)`
    <section 
      aria-labelledby="skills-heading" 
      data-profile-section="skills"
      class="profile__section--empty profile__section--empty-sidebar profile-section-collapsible profile-section-collapsible--inline-mobile-actions" 
      role="region"
      tabindex="-1"
      data-expanded="false"
    >
      <header class="profile__section-header profile-section-collapsible__header">
        <h3 id="skills-heading" tabindex="-1">${_texts.skillsHeadingText}</h3>
        <div class="profile-section-collapsible__actions">
          <solid-ui-button
            type="button"
            variant="secondary"
            size="sm"
            class="profile__action-button profile-action-text profile-section-collapsible__edit-button"
            aria-label="Add skills"
            @click=${event => {
    return (0, _SkillsEditDialog.createSkillsEditDialog)(event, store, subject, skills, viewerMode, onSaved);
  }}
          >
            <span class="profile-section-collapsible__edit-label profile__add-more-content">
              <span class="profile__add-more-icon" aria-hidden="true">${_profileIcons.addIcon}</span>
              <span>Add More</span>
            </span>
            <span class="profile-section-collapsible__edit-icon" aria-hidden="true">${_profileIcons.editIcon}</span>
          </solid-ui-button>
          <solid-ui-button
            type="button"
            variant="icon"
            size="sm"
            class="profile-section-collapsible__toggle-button"
            aria-label="Toggle skills section"
            aria-controls="skills-panel"
            aria-expanded="false"
            @click=${_collapsibleSection.toggleCollapsibleSection}
          >
            <span slot="icon" class="profile-section-collapsible__chevron" aria-hidden="true">${_profileIcons.chevronDownIcon}</span>
          </solid-ui-button>
        </div>
      </header>
      <div id="skills-panel" class="profile-section-collapsible__content">
        ${renderOwnerEmptySkillsContent(store, subject, skills, viewerMode, onSaved)}
      </div>
    </section>
  `;
}
function renderSkillsSection(store, subject, skills, viewerMode, onSaved) {
  const safeSkills = skills || [];
  const hasSkills = Array.isArray(safeSkills) && safeSkills.length > 0;
  const showOwnerEmptySkills = !hasSkills && viewerMode === 'owner';
  const showSection = true;
  return showSection ? (0, _litHtml.html)`
    ${showOwnerEmptySkills ? renderOwnerEmptySkillsSection(store, subject, safeSkills, viewerMode, onSaved) : renderSkillsSectionDefault(store, subject, safeSkills, viewerMode, onSaved)}
  ` : '';
}